import {create} from "zustand"


type DialogFormContextType = {
    showFormDialog: boolean
    currentId?: string,
    openDialog: (id?: string) => void
    closeDialog: () => void
}


export const useDialogFormState = create<DialogFormContextType>(set => ({
    showFormDialog: false,
    currentId: undefined,
    openDialog: (id?: string) => {
        if (typeof id === "string") {
            set({showFormDialog: true, currentId: id})
        } else {

            set({showFormDialog: true, currentId: undefined})
        }

    },
    closeDialog: () => set({showFormDialog: false}),
}))

export const useDialogFormContext = () => {
    const showDialog = useDialogFormState(state => state.showFormDialog)
    const openDialog = useDialogFormState(state => state.openDialog)
    const closeDialog = useDialogFormState(state => state.closeDialog)
    const currentId = useDialogFormState(state => state.currentId)

    return {showDialog, openDialog, closeDialog, currentId}
}